__turbopack_context__.v({
  "arrow": "Tooltip-module__qnEvEW__arrow",
  "fadeIn": "Tooltip-module__qnEvEW__fadeIn",
  "positioner": "Tooltip-module__qnEvEW__positioner",
  "tooltip": "Tooltip-module__qnEvEW__tooltip",
});
